/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */

import React from 'react'
import { Link } from 'react-router-dom'

class ForShop extends React.Component {
  render() {
    return (
      <nav
        className="pcoded-navbar noprint"
        id="admin_menu"
      >
        <div className="pcoded-inner-navbar main-menu">
          <ul className="pcoded-item pcoded-left-item">
            <li className="">
              <Link to="/">
                <span className="pcoded-micon">
                  <i className="feather icon-home"></i>
                </span>
                <span className="pcoded-mtext">Dashboard</span>
              </Link>
            </li>

            <li className=" pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <i className="icofont icofont-cart-alt"></i>
                </span>
                <span className="pcoded-mtext">Booking</span>
              </a>
              <ul className="pcoded-submenu">
                <li className=" ">
                  <Link to="/booking-order">
                    <span className="pcoded-mtext">Bookings</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/booking-order-v2">
                    <span className="pcoded-mtext">Bookings V2</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/chalet-bookings">
                    <span className="pcoded-mtext">Chalet Bookings</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/current-booking">
                    <span className="pcoded-mtext">Current Bookings</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/store-bookings">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-opposite"></i>
                    </span>
                    <span className="pcoded-mtext">Store Orders</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/booking-payments">
                    <span className="pcoded-mtext">Booking Payments</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="">
              <Link to="/store-details">
                <span className="pcoded-micon">
                  <i className="icofont icofont-brand-appstore"></i>
                </span>
                <span className="pcoded-mtext">Stores</span>
              </Link>
            </li>
            {/* <li className=" pcoded-hasmenu">
							<a href="javascript:void(0)">
								<span className="pcoded-micon">
									<i className="icofont icofont-cart-alt"></i>
								</span>
								<span className="pcoded-mtext">Store Master</span>
							</a>
							<ul className="pcoded-submenu">
								<li className="">
									<Link to="/store-details">
										<span className="pcoded-micon">
											<i className="icofont icofont-brand-appstore"></i>
										</span>
										<span className="pcoded-mtext">Stores</span>
									</Link>
								</li>
							</ul>
						</li> */}
          </ul>
        </div>
      </nav>
    )
  }
}

export default ForShop
